import { useForm, useWatch } from 'react-hook-form'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useIntl } from 'react-intl'

const usePersonalDataForm = () => {
  const { formatMessage: f } = useIntl()
  const {
    control, setValue, onSubmit: handleSubmit, formState, getValues,
  } = useForm({
    resolver: yupResolver(
      yup.object().shape({
        user: yup
          .string()
          .email(f({ id: 'APPRAISAL_PLEASE_ENTER_VALID_EMAIL' }))
          .required(f({ id: 'APPRAISAL_PLEASE_ENTER_EMAIL' }))
          // eslint-disable-next-line no-useless-escape
          .matches(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, f({ id: 'APPRAISAL_PLEASE_ENTER_VALID_EMAIL' })),
        password: yup.string().required(),
      }),
    ),
    defaultValues: {
      user: '',
      password: '',
    },
    mode: 'all',
  })
  const [
    user,
    password,
  ] = useWatch({
    control,
    name: [
      'user',
      'password',
    ],
  })

  return {
    setValue,
    getValues,
    onSubmit: handleSubmit,
    formState,
    control,
    user,
    password,
  }
}

export default usePersonalDataForm
